// Imports
import { useTheme } from 'styled-components/macro';
import generateStripeAppearance from '../../../../../../shareables/front-end/stripe-component-wrappers/utils/generate-stripe-appearance';
import { GeneratedThemeProps } from '../../../../../templates/template-style';


// A hook that creates a custom Stripe appearance object
const useStripeAppearance = () => {
	// Use styled components functionality
	const templateTheme = useTheme();
	
	
	// Type guard
	function isGeneratedTheme(templateTheme: unknown): templateTheme is GeneratedThemeProps {
		return templateTheme !== null && typeof templateTheme === 'object' && 'baseColor' in templateTheme;
	}
	
	if (!isGeneratedTheme(templateTheme)) {
		throw new Error('This should not be possible');
	}
	
	
	// Return custom Stripe appearance
	return generateStripeAppearance({ primaryColor: templateTheme.baseColor, fontFamily: templateTheme.fontFamily });
};

export default useStripeAppearance;
